/**
 * Layout component 
 */

import React from "react"
import PropTypes from "prop-types"

import FutureHeader from "../futureheader"
import Footer from "../footer"
import FutureSEO from "../futureseo"

import styles from "./futurelayout.module.css"
/*import "./itmodlayout.css"*/

const Layout = ({ children }) => {

  return (
    <>
      <FutureSEO title="Home" />
      <FutureHeader />
      <div className={`container ${styles.container}`}>
        <main>{children}</main>
        <Footer />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout